import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) { navigate("/"); return; }
    loginWithGoogle(sid)
      .then(() => { toast.success("Signed in with Google"); navigate("/dashboard"); })
      .catch(() => { toast.error("Google sign-in failed. Please try again."); navigate("/"); });
  }, [loginWithGoogle, navigate]);

  return (
    <div data-testid="google-callback" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#08080a", color: "var(--muted)" }}>
      <div style={{ textAlign: "center" }}>
        <div className="font-serif" style={{ fontSize: "1.6rem", marginBottom: "0.8rem" }}>
          <span style={{ color: "var(--text)" }}>DSCR</span><span style={{ color: "var(--gold)" }}>Daily</span>
        </div>
        Signing you in…
      </div>
    </div>
  );
}
